import api from '@/services/api';
import type { ProductAddOnGroupRecord } from './addonGroup.types';

const smrPath = '/smr';

export interface AssignAddOnGroupPayload {
    addon_group_id: string;
}

export const fetchProductAddOnGroups = async (
    productId: string,
): Promise<ProductAddOnGroupRecord[]> => {
    const res = await api.get(`${smrPath}/products/${productId}/addon-groups`);
    return (res.data.data ?? []) as ProductAddOnGroupRecord[];
};

export const assignAddOnGroupToProduct = async (
    productId: string,
    payload: AssignAddOnGroupPayload,
): Promise<ProductAddOnGroupRecord> => {
    const res = await api.post(`${smrPath}/products/${productId}/addon-groups`, payload);
    return res.data.data as ProductAddOnGroupRecord;
};

export const removeAddOnGroupFromProduct = async (
    productId: string,
    addonGroupId: string,
): Promise<void> => {
    await api.delete(`${smrPath}/products/${productId}/addon-groups/${addonGroupId}`);
};
